import { render } from "./AddReceiverReportPage.vue?vue&type=template&id=5c0c0c82&ts=true"
import script from "./AddReceiverReportPage.vue?vue&type=script&lang=ts"
export * from "./AddReceiverReportPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/TTYT_NHS/ZaloOA/ZaloOA_TTYT_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__